import { MapPage } from "./pages/MapPage";
import { LanguageSwitcher } from "./components/LanguageSwitcher";
import { useLanguage } from "./i18n/LanguageContext";

export default function App() {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-4">
          <h1 className="text-xl font-bold text-slate-900">{t("app.title")}</h1>
          <LanguageSwitcher />
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6">
        <MapPage />
      </main>
    </div>
  );
}
